import { useTranslation } from "@/context/TranslationContext";

const steps = [
  {
    number: "01",
    titleKey: "home_process.step1_title",
    descKey: "home_process.step1_desc",
    icon: "ri-search-eye-line",
    detailKey: "home_process.step1_detail",
  },
  {
    number: "02",
    titleKey: "home_process.step2_title",
    descKey: "home_process.step2_desc",
    icon: "ri-layout-masonry-line",
    detailKey: "home_process.step2_detail",
  },
  {
    number: "03",
    titleKey: "home_process.step3_title",
    descKey: "home_process.step3_desc",
    icon: "ri-code-s-slash-line",
    detailKey: "home_process.step3_detail",
  },
  {
    number: "04",
    titleKey: "home_process.step4_title",
    descKey: "home_process.step4_desc",
    icon: "ri-shield-check-line",
    detailKey: "home_process.step4_detail",
  },
  {
    number: "05",
    titleKey: "home_process.step5_title",
    descKey: "home_process.step5_desc",
    icon: "ri-rocket-line",
    detailKey: "home_process.step5_detail",
  },
];

export default function ProcessSection() {
  const { t } = useTranslation();
  return (
    <section className="bg-dark-panel py-28 px-4 md:px-12 lg:px-20 border-t border-dark-border">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-20 gap-6">
          <div>
            <span className="inline-block text-electric-blue text-xs font-semibold uppercase tracking-[0.2em] mb-5 px-3 py-1.5 border border-electric-blue/25 rounded-full bg-electric-blue/5">
              {t("home_process.badge")}
            </span>
            <h2 className="font-black text-white leading-tight" style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: "clamp(2rem, 4vw, 3.5rem)" }}>
              {t("home_process.title")}<br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-electric-blue to-cyber-blue">
                {t("home_process.highlight")}
              </span>
            </h2>
          </div>
          <p className="text-silver text-sm max-w-sm leading-relaxed lg:text-right">
            {t("home_process.description")}
          </p>
        </div>

        {/* Steps grid */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-0 relative">
          {/* Horizontal connector */}
          <div className="hidden md:block absolute top-10 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-electric-blue/20 to-transparent" />

          {steps.map((step, index) => (
            <div key={step.number} className="relative group flex flex-col md:items-center text-left md:text-center px-4 pb-10 md:pb-0">
              {/* Step icon box */}
              <div className="relative mb-6">
                <div className="w-20 h-20 flex items-center justify-center rounded-2xl bg-dark-card border border-dark-border group-hover:border-electric-blue/40 group-hover:bg-electric-blue/5 transition-all duration-300">
                  <i className={`${step.icon} text-2xl text-electric-blue`} />
                </div>
                {/* Number badge */}
                <div className="absolute -top-3 -right-3 w-7 h-7 flex items-center justify-center rounded-full bg-deep-black border border-electric-blue/40 text-electric-blue text-xs font-black">
                  {index + 1}
                </div>
              </div>

              {/* Duration pill */}
              <span className="inline-block text-xs px-2.5 py-1 rounded-full border border-dark-border text-silver-dim mb-3 whitespace-nowrap">
                {t(step.detailKey)}
              </span>

              <h3 className="text-white font-bold text-sm mb-2 leading-snug" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                {t(step.titleKey)}
              </h3>
              <p className="text-silver-dim text-xs leading-relaxed">
                {t(step.descKey)}
              </p>

              {/* Mobile connector */}
              {index < steps.length - 1 && (
                <div className="md:hidden absolute left-10 bottom-0 w-px h-10 bg-gradient-to-b from-electric-blue/30 to-transparent" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
